import React, { useEffect, useState } from "react";
import { useClientColyseus } from "../../Contexts/ClientColyseusContext";

import PlayerNamePrompt from "./PlayerNamePrompt";

const FormCreateRoom = ({ playerName, onBack }) => {
  const {
    createRoom,
    courses,
    coursesLoaded,
  } = useClientColyseus();
  const [form, setForm] = useState({
    name: `${playerName}'s Room`,
    pwd: "",
    course: "",
    course_id: "",
    mod: "speed_duel",
    mode: "competitive", // New field for mode
    maxPlayer: 8,
    nbQuestions: 5,
    playerName: playerName
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (coursesLoaded && courses.length > 0 && !form.course_id) {
      setForm((prev) => ({
        ...prev,
        course: courses[0].course_title,
        course_id: courses[0].course_id,
      }));
    }
  }, [coursesLoaded, courses, form.course_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleCourse = (e) => {
    const selected = courses.find((c) => c.course_title === e.target.value);
    setForm((prev) => ({
      ...prev,
      course: selected.course_title,
      course_id: selected.course_id,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      console.log("Creating room with player name:", playerName);
      console.log("Form data:", form);
      
      const createdRoom = await createRoom(
        form.mod,
        form.name,
        form.pwd,
        form.course,
        form.course_id,
        form.nbQuestions,
        form.mode,
        { name: playerName }
      );
      
      console.log("Room creation result:", createdRoom);
      
      if (createdRoom && createdRoom.id) {
        console.log("Successfully created room:", createdRoom.id);
        // Room creation successful, user will be automatically redirected to the room
      } else {
        throw new Error("Room creation did not return a valid room");
      }
      
    } catch (err) {
      console.error("Error creating room:", err);
      setError(`Failed to create room: ${err.message}. Please try again.`);
      setLoading(false);
    }
  };
  return (
    <div className="bg-white rounded-xl shadow-lg p-8 max-w-2xl mx-auto">
      {error && (
        <div className="mb-6 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
          {error}
        </div>
      )}
      
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid md:grid-cols-1 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Room Name</label>
            <input 
              type="text" 
              name="name" 
              value={form.name} 
              onChange={handleChange} 
              className="w-full border-2 border-gray-300 rounded-lg px-4 py-2 focus:border-indigo-500 focus:outline-none"
              placeholder="Enter room name"
            />
          </div>
          
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Room Password (Optional)</label>
            <input 
              type="password" 
              name="pwd" 
              value={form.pwd} 
              onChange={handleChange} 
              className="w-full border-2 border-gray-300 rounded-lg px-4 py-2 focus:border-indigo-500 focus:outline-none"
              placeholder="Leave empty for public room"
            />
          </div> */}
        </div>

        <div className="grid md:grid-cols-1 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Course</label>
            <select 
              name="course" 
              value={form.course} 
              onChange={handleCourse} 
              className="w-full border-2 border-gray-300 rounded-lg px-4 py-2 focus:border-indigo-500 focus:outline-none"
            >
              {courses.map((course, idx) => (
                <option key={idx} value={course.course_title}>{course.course_title}</option>
              ))}
            </select>
          </div>
          
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Max Players</label>
            <select 
              name="maxPlayer" 
              value={form.maxPlayer} 
              onChange={handleChange} 
              className="w-full border-2 border-gray-300 rounded-lg px-4 py-2 focus:border-indigo-500 focus:outline-none"
            >
              <option value="2">2 Players</option>
              <option value="4">4 Players</option>
              <option value="6">6 Players</option>
              <option value="8">8 Players</option>
            </select>
          </div> */}
        </div>

        <div className="grid md:grid-cols-1 gap-6">
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Game Mode</label>
            <select 
              name="mode" 
              value={form.mode} 
              onChange={handleChange} 
              className="w-full border-2 border-gray-300 rounded-lg px-4 py-2 focus:border-indigo-500 focus:outline-none"
            >
              <option value="competitive">🏆 Competitive (Individual Scores)</option>
              <option value="cooperative">🤝 Cooperative (Team Score)</option>
            </select>
          </div> */}
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Number of Questions</label>
            <select 
              name="nbQuestions" 
              value={form.nbQuestions} 
              onChange={handleChange} 
              className="w-full border-2 border-gray-300 rounded-lg px-4 py-2 focus:border-indigo-500 focus:outline-none"
            >
              <option value="5">5 Questions (Quick)</option>
              <option value="10">10 Questions (Standard)</option>
              <option value="20">20 Questions (Extended)</option>
              <option value="40">40 Questions (Marathon)</option>
            </select>
          </div>
        </div>

        <div className="flex gap-4 pt-4">
          <button
            type="button"
            onClick={onBack}
            className="flex-1 bg-gray-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-gray-700 transition-colors"
            disabled={loading}
          >
            ← Back to Lobby
          </button>
          
          <button 
            type="submit" 
            className="flex-1 bg-indigo-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-indigo-700 transition-colors disabled:opacity-50"
            disabled={loading}
          >
            {loading ? "Creating Room..." : "Create Room"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default FormCreateRoom;
